import { render, staticRenderFns } from "./DictionaryLiteratures.vue?vue&type=template&id=74e80ef1&"
import script from "./DictionaryLiteratures.vue?vue&type=script&lang=js&"
export * from "./DictionaryLiteratures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports